import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDubbelGlas = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="m33 33-22-6V5l22 6z"
    />
    <path
      fill="#85E3F9"
      d="M29 35 7 29V7l22 6z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m17.61 22.71-5.42 4.06-.54-.72 5.42-4.06zM23.31 15.92l-9.05 6.79-.54-.72 9.05-6.79z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDubbelGlas);

export default ForwardRef;
